import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  ratingReported: {
    defaultMessage: 'Vielen Dank für deine Einschätzung.',
    id: 'rating.rating-reported',
  },
  ratingReportError: {
    defaultMessage: 'Feedback konnte nicht abgegeben werden.',
    id: 'rating.rating-report-error',
  },
  reportRating: {
    defaultMessage: 'Bewertung melden',
    id: 'rating.report-rating',
  },
});
